import React, { useCallback, useState } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import LightbulbIcon from '@atlaskit/icon/core/lightbulb';
import { RemixContainer } from '@atlassian/malleable-ui-components';
import { ToolbarButton, ToolbarButtonGroup, ToolbarTooltip } from '@atlaskit/editor-toolbar';

const messages = defineMessages({
	remixLabel: {
		id: 'highlight-actions.remix.toolbar-label',
		defaultMessage: 'Remix',
		description: 'Label for the Remix button in the highlight actions floating toolbar',
	},
});

export const HighlightActionsRemixButton = ({
	isNewToolbarEnabled,
}: {
	isNewToolbarEnabled?: boolean;
}) => {
	const { formatMessage } = useIntl();
	const [isOpen, setIsOpen] = useState(false);
	const [selectedText, setSelectedText] = useState('');

	const handleOpen = useCallback(() => {
		const selection = window.getSelection();
		setSelectedText(selection?.toString() || '');
		setIsOpen(true);
	}, []);

	const handleClose = useCallback(() => {
		setIsOpen(false);
		setSelectedText('');
	}, []);

	const button = isNewToolbarEnabled ? (
		<ToolbarTooltip content={formatMessage(messages.remixLabel)}>
			<ToolbarButtonGroup>
				<ToolbarButton
					iconBefore={<LightbulbIcon label="" size="small" />}
					isSelected={isOpen}
					testId="highlight-actions-remix"
					onClick={handleOpen}
				>
					<FormattedMessage {...messages.remixLabel} />
				</ToolbarButton>
			</ToolbarButtonGroup>
		</ToolbarTooltip>
	) : (
		<ToolbarTooltip content={formatMessage(messages.remixLabel)}>
			<Button
				appearance="subtle"
				iconBefore={LightbulbIcon}
				isSelected={isOpen}
				testId="highlight-actions-remix"
				onClick={handleOpen}
			>
				<FormattedMessage {...messages.remixLabel} />
			</Button>
		</ToolbarTooltip>
	);

	return (
		<>
			{button}
			{isOpen && <RemixContainer selectedText={selectedText} onClose={handleClose} />}
		</>
	);
};
